import React from 'react'
import { ProductListGeneric } from '@zyn-common/components'

const ProductListCrossSell = ({ products, translations, ...rest }) => {
  return (
    <ProductListGeneric
      title={translations.tk_crossSell}
      isBundleList={false}
      products={products}
      translations={translations}
      {...rest}
    />
  )
}

export default ProductListCrossSell
